import React, { PureComponent } from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import { Table } from "reactstrap";
import PrintArea from "../../../common/component/PrintArea";
import PrintHeader from "../../../common/component/PrintHeader";
import { showCurrency, showDate, showQty } from "../../../common/function/showValueHelper";

type DPSalesPrintState = {
    data: any;
    companyInfo: any;
};

class DPSalesPrint extends PureComponent<WithTranslation, DPSalesPrintState> {
    constructor(props: any) {
        super(props);

        //load data from localStorage
        const stringData = localStorage.getItem("dp-sales-print");
        const jsonData = stringData != null ? JSON.parse(stringData) : null;

        // console.log(jsonData);
        // remove data from localStorage
        localStorage.removeItem("dp-sales-print");

        this.state = {
            data: jsonData && jsonData.data ? jsonData.data : null,
            companyInfo: jsonData && jsonData.companyInfo ? jsonData.companyInfo : null,
        };
    }

    render() {
        const { t } = this.props;
        const { companyInfo, data } = this.state;
        if (data == null) return <p>No Data</p>;
        //PO detail
        let columns = data.soDetails.map((obj: any, index: number) => {
            return (
                <tr key={"detail-" + index}>
                    <td>{index + 1}</td>
                    <td>{obj.product.name}</td>
                    <td>
                        {showQty(obj.qty)} {obj.unit?.name ?? obj.product.unit.name}
                    </td>
                    <td>{showCurrency(obj.price, 2)}</td>
                    <td>{showCurrency(obj.disc1, 2)}</td>
                    <td>{showCurrency(obj.subtotal, 2)}</td>
                </tr>
            );
        });

        let companyPaymentInfo = companyInfo.find((val: any) => {
            return val.key === "company-payment-info"
        });

        return (
            <PrintArea>
                <Table className="ra-table-print">
                    <PrintHeader
                        title={t("common.dpSales")}
                        companyInfo={companyInfo}
                        customer={data.customer}
                        no={data.key}
                        dtCreated={data.dtCreated}
                    />
                    <tbody>
                        <tr>
                            <th colSpan={2}>
                                {t("common.salesOrderInfo")}
                                <br />
                                {t("common.salesOrder")} No: {data.soData.key}
                                <br />
                                {t("common.soDate")}: {showDate(data.soData.dtCreated)}
                            </th>
                        </tr>
                        <tr>
                            <td colSpan={2}>
                                <Table className="ra-table-detail-print">
                                    <thead>
                                        <tr>
                                            <th className="rowNo">#</th>
                                            <th>{t("common.product")}</th>
                                            <th>{t("common.qty")}</th>
                                            <th>{t("common.price")}</th>
                                            <th>{t("common.discount")}</th>
                                            <th>{t("common.subTotal")}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {columns}
                                        <tr>
                                            <td colSpan={4} rowSpan={6} />
                                            <td>{t("common.discount")}</td>
                                            <td>{showCurrency(data.soData.disc2AmountTotal)}</td>
                                        </tr>
                                        <tr>
                                            <td>{t("common.subTotal")}</td>
                                            <td>{showCurrency(data.soData.amountTotal)}</td>
                                        </tr>
                                        <tr>
                                            <td>{t("common.tax")}</td>
                                            <td>{showCurrency(data.soData.tax)}</td>
                                        </tr>
                                        <tr>
                                            <td>{t("common.grandTotal")}</td>
                                            <td>{showCurrency(data.soData.grandTotal)}</td>
                                        </tr>
                                        <tr>
                                            <td>{t("common.downPayment")}</td>
                                            <td>{showCurrency(data.amount)}</td>
                                        </tr>
                                        <tr>
                                            <td colSpan={2}>
                                                <b>{t("common.calculatedDownPayment")}: </b> <br />
                                                {data.say} {" "} Rupiah
                                            </td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </td>
                        </tr>
                        <tr>
                            <td colSpan={2}>
                                {companyPaymentInfo.value !== "" ? (
                                    <>
                                        <strong>{t("common.paymentInfo")}</strong>
                                        <p>{companyPaymentInfo.value}</p>
                                    </>
                                ) : ""}
                            </td>
                        </tr>
                    </tbody>
                </Table>
            </PrintArea>
        );
    }
}

export default withTranslation()(DPSalesPrint);
